import EmblaCarousel from 'embla-carousel';

const SLIDE_SELECTOR = '.testimonials-carousel__slide';

const OPTIONS = {
  align: 'start',
  loop: true,
  duration: window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 0
    : 25,
  slides: SLIDE_SELECTOR,
};

const visibleSlides = (root) =>
  [...root.querySelectorAll(SLIDE_SELECTOR)].filter((slide) => !slide.hidden);

const initTestimonialsCarousel = (root) => {
  const viewport = root.querySelector('.testimonials-carousel__viewport');
  if (!viewport) return;

  const id = root.getAttribute('data-testimonials-carousel');
  const prevBtn = root.querySelector('[data-testimonials-carousel-btn="prev"]');
  const nextBtn = root.querySelector('[data-testimonials-carousel-btn="next"]');
  const filterGroup = id
    ? document.querySelector(`[data-testimonials-filter="${id}"]`)
    : null;

  const emblaApi = EmblaCarousel(viewport, OPTIONS);

  const updateButtons = () => {
    if (prevBtn) prevBtn.disabled = !emblaApi.canScrollPrev();
    if (nextBtn) nextBtn.disabled = !emblaApi.canScrollNext();
  };

  emblaApi.on('select', updateButtons);
  emblaApi.on('reInit', updateButtons);

  if (prevBtn) {
    prevBtn.addEventListener('click', () => emblaApi.scrollPrev());
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => emblaApi.scrollNext());
  }

  if (filterGroup) {
    const slides = root.querySelectorAll(SLIDE_SELECTOR);
    const buttons = filterGroup.querySelectorAll('[data-filter]');

    const applyFilter = (schoolId) => {
      slides.forEach((slide) => {
        const match =
          !schoolId || slide.getAttribute('data-school') === schoolId;
        slide.hidden = !match;
      });

      buttons.forEach((btn) => {
        const isActive = (btn.getAttribute('data-filter') || '') === schoolId;
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.classList.toggle('btn--outline', !isActive);
      });

      emblaApi.reInit({ slides: visibleSlides(root) });
      emblaApi.scrollTo(0, true);
    };

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        applyFilter(btn.getAttribute('data-filter') || '');
      });
    });
  }

  updateButtons();
};

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-testimonials-carousel]')
    .forEach(initTestimonialsCarousel);
});
